import React, { Component } from "react";
import Stats from "./Stats";
import Update from "./Update";
import Info from "./Info";
import UserCreatedGraph from "./UserCreatedGraph";
import PieGraph from "./PieGraph";
import Search from "../Search/Home";

export default class Home extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getStats } = this.props;
    updateHeader({
      title: "User Activity",
      description: ""
    });
    updateBreadcrumb([{ label: "Home", link: "/" }]);
  }
  render() {
    return (
      <div>
        <UserCreatedGraph/>
        <PieGraph/>
        <Search/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Home/index.js